import { API_SLETAT_HOST_NAME } from '../../consts/hosts';
import { PayloadType, HotelReviewsReq } from '../models/hotel-reviews';

async function fetchReviews(hotelId: number, payload: PayloadType): Promise<HotelReviewsReq> {
    const options = {
        hotelId,
        ...payload,
    };
    const response = await fetch(`https://${API_SLETAT_HOST_NAME}/hotels/reviews/search`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(options),
    });
    return response.json();
}

export function getReviews(id: number, payload: PayloadType): Promise<HotelReviewsReq> {
    return fetchReviews(id, payload);
}
